import {setCommonMetrics} from '@spa/features/search_job/pc/api/analytics/base';
import analyticsHelper from "@spa/utils/analyticsHelper";

/**
 * ジョブアラート登録イベントを計測
 * @param registerResult
 * @param isFromPaidJob
 * @param position
 */
export const trackJobAlertRegister = (registerResult, isFromPaidJob, position) => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        /*
        subscribeボタン押下時に"ページ種別"と"押下箇所"を取得。
        　└search_result_pft,jobPanel
        　└search_result_pft,Bottom
        　└search_result_normal,jobPanel
        　└search_result_normal,Bottom
         */
        const page = 'search_result';
        const type = isFromPaidJob ? 'pft' : 'normal';
        const jobAlertPosition = position === 'jobPanel' ? 'jobPanel' : 'Bottom';
        s.linkTrackVars = 'channel,prop1,prop57,prop71,eVar50,eVar58';
        s.channel = 'buttonclick';
        s.prop1 = 'BC_jobAlert_subscribe_click';
        s.eVar50 = `${page}_${type},${jobAlertPosition}`;
        /*
        subscribeボタン押下時に"エラー状況"を取得。
        　└jobAlert_subscribe_click_success
        　└jobAlert_subscribe_click_confirm（ダブルオプトイン専用）
        　└jobAlert_subscribe_click_error
         */
        s.eVar58 = `jobAlert_subscribe_click_${registerResult}`;
        s.tl(this, 'o', s.prop1);
    });
};

/**
 * フィルタークリック時の計測処理
 * @param analyticsOriginalPageProp - 元ページのprop
 */
export const trackClickJobFilterSearch = (analyticsOriginalPageProp) => {
    if (!analyticsOriginalPageProp) {
        return;
    }
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        s.linkTrackVars = "channel,prop1,prop57,prop71,eVar50";
        s.channel = "buttonclick";
        s.prop1 = "BC_jobFilter_search_click";
        s.eVar50 = analyticsOriginalPageProp;
        s.tl(this, 'o', s.prop1);
    });
};

/**
 * 求人パネルクリック時の計測処理
 * @param analyticsData
 * @param postedAt
 * @param currentPage
 * @param position
 * @param isSaved
 * @return {void}
 */
export const trackClickSearchResult = (analyticsData, postedAt, currentPage, position, isSaved) => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        const type = analyticsData.type === 'pft' ? 'Paid For Transition' : analyticsData.type;
        setCommonMetrics();
        s.linkTrackVars = "channel,prop1,prop45,prop57,prop71,eVar31,eVar32,eVar33,eVar34,eVar35,eVar36,eVar38,eVar39,eVar41,eVar45,eVar50,events";
        s.linkTrackEvents = "event2,event102";
        s.channel = "searchresult_click";
        s.prop1 = "searchresult_click"
        s.prop45 = type;
        s.eVar31 = analyticsData.uniqueId;
        s.eVar32 = analyticsData.sourceName;
        s.eVar33 = postedAt;
        s.eVar34 = analyticsData.companyNameExistence;
        s.eVar35 = analyticsData.title;
        s.eVar36 = analyticsData.companyName;
        s.eVar38 = analyticsData.jobType;
        s.eVar39 = analyticsData.salaryValue;
        s.eVar41 = analyticsData.location;
        s.eVar45 = type;
        s.eVar50 = "searchresult," + currentPage + "," + position;
        s.events = "event2" + (isSaved ? ",event102" : "");
        s.tl(this, 'o', s.prop1);
    });
}

/**
 * 検索結果初回ランディング時の計測処理
 * @param analyticsData
 * @param location
 * @param postedAt
 * @param currentPage
 * @param position
 * @param isSaved
 * @return {void}
 */
export const trackJobViewFirst = (analyticsData, location, postedAt, currentPage, position, isSaved) => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        const type = analyticsData.type === 'pft' ? 'Paid For Transition' : analyticsData.type;
        setCommonMetrics();
        s.linkTrackVars = "channel,prop1,prop45,prop57,prop71,eVar31,eVar32,eVar33,eVar34,eVar35,eVar36,eVar38,eVar39,eVar41,eVar45,eVar50,events";
        s.linkTrackEvents = "event102";
        s.channel = "searchresult_jobview_first";
        s.prop1 = "searchresult_jobview_first";
        s.prop45 = type;
        s.eVar31 = analyticsData.uniqueId;
        s.eVar32 = analyticsData.sourceName;
        s.eVar33 = postedAt;
        s.eVar34 = analyticsData.companyNameExistence;
        s.eVar35 = analyticsData.title;
        s.eVar36 = analyticsData.companyName;
        s.eVar38 = analyticsData.jobTypes;
        s.eVar39 = analyticsData.salaryValue;
        s.eVar41 = location;
        s.eVar45 = type;
        s.eVar50 = "searchresult," + currentPage + "," + position;
        s.events = isSaved ? "event102" : "";
        s.tl(this, 'o', s.prop1);
    });
}

/**
 * リンクコピーイベントを計測
 * @param {string} channelName クリック元ページのchannelName
 */
export const trackLinkCopy = (channelName) => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        s.linkTrackVars = 'channel,prop1,prop57,prop71,eVar50';
        s.channel = 'buttonclick';
        s.prop1 = 'BC_linkCopy_click';
        s.eVar50 = channelName;
        s.tl(this, 'o', s.prop1);
    });
}

/**
 * フィルターのAll Clearボタン押下時の計測処理
 * @param analyticsOriginalPageProp - 元ページのprop
 */
export const trackClickAllClear = (analyticsOriginalPageProp) => {
    if(!analyticsOriginalPageProp) {
        return;
    }
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        s.linkTrackVars = "channel,prop1,prop57,prop71,eVar50";
        s.channel = "buttonclick";
        s.prop1 = "BC_jobFilter_allClear_click";
        s.eVar50 = analyticsOriginalPageProp;
        s.tl(this, 'o', s.prop1);
    });
};

/**
 * 特徴のShow more クリックイベントを計測
 * @param {string} channelName クリック元ページのchannelName
 */
export const trackShowMore = (channelName) => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        s.linkTrackVars = 'channel,prop1,prop57,prop71,eVar50';
        s.channel = 'buttonclick';
        s.prop1 = 'BC_showMore_click';
        s.eVar50 = channelName;
        s.tl(this, 'o', s.prop1);
    });
};

/**
 * 特徴のShow more クリックイベントを計測
 * @param {string} channelName クリック元ページのchannelName
 */
export const trackLinkDetailPage = (channelName) => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        s.linkTrackVars = 'channel,prop1,prop57,prop71,eVar50';
        s.channel = 'buttonclick';
        s.prop1 = 'BC_linkToDetailPage_click';
        s.eVar50 = channelName;
        s.tl(this, 'o', s.prop1);
    });
};

/**
 * 求人詳細送客 クリックイベントを計測
 * @param {JobDetailData} JobDetailData
 * @param {number} position
 * @param {boolean} isSaved
 */
export const trackDetailCv = (JobDetailData, position, isSaved) => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        const analyticsViewModel = JobDetailData.analyticsViewModel;
        const channel = 'jobdetail_click'

        s.linkTrackVars = 'channel,prop1,prop2,prop9,prop31,prop32,prop38,prop39,prop41,prop45,prop57,prop71,eVar45,eVar50,events';
        s.linkTrackEvents = 'event1,event8,event101,event99,event100,event108';
        s.channel = channel;
        s.prop1 = channel;
        s.prop2 = `${channel},searchresult_jobview`;
        s.prop9 = String(analyticsViewModel.isIndex);
        s.prop31 = analyticsViewModel.uniqueId;
        s.prop32 = analyticsViewModel.sourceName;
        s.prop38 = analyticsViewModel.jobTypes;
        s.prop39 = analyticsViewModel.salary;
        s.prop41 = analyticsViewModel.location;
        s.prop45 = analyticsViewModel.type;
        s.eVar45 = s.prop45;
        s.eVar50 = 'searchresult_jobview,cvs,' + position;
        s.events = 'event1,event8' + (isSaved ? ',event101,event108' : '');
        if (analyticsViewModel.maskedCost) {
            s.events += ',event99=' + analyticsViewModel.maskedCost;
        }
        if (analyticsViewModel.convertedAndMaskedCost) {
            s.events += ',event100=' + analyticsViewModel.convertedAndMaskedCost;
        }
        s.tl(this, 'o', s.prop1);
    });
};

/**
 * お気に入り登録時 クリックイベントを計測
 * @param {string} channelName クリック元ページのchannelName
 * @param {string} jobUniqueId クリックした求人のuniqueId
 */
export const trackSaveJobButtonOn = (channelName, jobUniqueId) => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        s.linkTrackVars = 'channel,prop1,prop57,prop71,eVar31,eVar50';
        s.channel = 'buttonclick';
        s.prop1 = 'BC_savedJob_on_click';
        s.eVar31 = jobUniqueId;
        s.eVar50 = channelName;
        s.tl(this, 'o', s.prop1);
    });
};

/**
 * お気に入り削除時 クリックイベントを計測
 * @param {string} channelName クリック元ページのchannelName
 * @param {string} jobUniqueId クリックした求人のuniqueId
 */
export const trackSaveJobButtonOff = (channelName, jobUniqueId) => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        s.linkTrackVars = 'channel,prop1,prop57,prop71,eVar31,eVar50';
        s.channel = 'buttonclick';
        s.prop1 = 'BC_savedJob_off_click';
        s.eVar31 = jobUniqueId;
        s.eVar50 = channelName;
        s.tl(this, 'o', s.prop1);
    });
};

/**
 * 検索ボタン クリックイベントを計測
 * @param {string} channelName クリック元ページのchannelName
 */
export const trackSearchBoxSearchClick = (channelName) => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        s.linkTrackVars = 'channel,prop1,prop57,prop71,eVar50';
        s.channel = 'buttonclick';
        s.prop1 = 'BC_searchBox_search_click';
        s.eVar50 = channelName;
        s.tl(this, 'o', s.prop1);
    });
};

/**
 * 勤務地サジェスト サジェストのクリックイベントを計測
 * @param {string} channelName クリック元ページのchannelName
 */
export const trackSearchBoxLocationSuggest = (channelName) => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        s.linkTrackVars = 'channel,prop1,prop57,prop58,prop71,eVar50';
        s.channel = 'buttonclick';
        s.prop1 = 'BC_searchBox_suggest_click';
        s.prop58 = 'locationSuggest';
        s.eVar50 = channelName;
        s.tl(this, 'o', s.prop1);
    });
}

/**
 * キーワードサジェスト サジェストのクリックイベントを計測
 * @param {string} channelName クリック元ページのchannelName
 */
export const trackSearchBoxKeywordSuggest = (channelName) => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        s.linkTrackVars = 'channel,prop1,prop57,prop58,prop71,eVar50';
        s.channel = 'buttonclick';
        s.prop1 = 'BC_searchBox_suggest_click';
        s.prop58 = 'keywordSuggest';
        s.eVar50 = channelName;
        s.tl(this, 'o', s.prop1);
    });
}

/**
 * 検索窓での検索実行時のイベントを計測
 * @param {string} channelName クリック元ページのchannelName
 */
export const trackSearchBoxTotalClick = (channelName) => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        s.linkTrackVars = 'channel,prop1,prop57,prop71,eVar50';
        s.channel = 'buttonclick';
        s.prop1 = 'BC_searchBox_total_click';
        s.eVar50 = channelName;
        s.tl(this, 'o', s.prop1);
    });
};

/**
 * ページング"Next" クリックイベントを計測
 * @param {string} channelName クリック元ページのchannelName
 */
export const trackPagingNext = (channelName) => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        s.linkTrackVars = 'channel,prop1,prop57,prop71,eVar50';
        s.channel = 'buttonclick';
        s.prop1 = 'BC_paging_next_click';
        s.eVar50 = channelName;
        s.tl(this, 'o', s.prop1);
    });
}

/**
 * ページング"Previous" クリックイベントを計測
 * @param {string} channelName クリック元ページのchannelName
 */
export const trackPagingPrevious = (channelName) => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        s.linkTrackVars = 'channel,prop1,prop57,prop71,eVar50';
        s.channel = 'buttonclick';
        s.prop1 = 'BC_paging_previous_click';
        s.eVar50 = channelName;
        s.tl(this, 'o', s.prop1);
    });
}

/**
 * 関連KW クリックイベントを計測
 * @param {string} channelName クリック元ページのchannelName
 */
export const trackRelateKeywords = (channelName) => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        s.linkTrackVars = 'channel,prop1,prop57,prop71,eVar50';
        s.channel = 'buttonclick';
        s.prop1 = 'BC_relatedKeyword_click';
        s.eVar50 = channelName;
        s.tl(this, 'o', s.prop1);
    });
}
